// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      const wlResponse = await fetch("../../config/proofs.json", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const proofs = await wlResponse.json();
      const account =  await store.getState().blockchain.account;
      const pos = proofs.map(function(e) { return e.address.toLowerCase(); }).indexOf(account.toLowerCase());
    
      let totalSupply = await store
        .getState()
        .blockchain.smartContract.methods.totalSupply()
        .call();

      let maxSupply = await store
        .getState()
        .blockchain.smartContract.methods.maxSupply()
        .call();

      let cost = await store
        .getState()
        .blockchain.smartContract.methods.price()
        .call();

      let allowListEnabled = await store
        .getState()
        .blockchain.smartContract.methods.onlyAllowlistMode()
        .call();

      let publicEnabled = await store
        .getState()
        .blockchain.smartContract.methods.mintEnabled()
        .call();

      let userMintAmt = await store
        .getState()
        .blockchain.smartContract.methods.numberMinted(account)
        .call()

      let maxPerWallet = await store 
        .getState()
        .blockchain.smartContract.methods.maxPerWallet()
        .call()

      let mintMode;
      if (allowListEnabled === true) {
        mintMode = "Whitelist"
      } else if (publicEnabled === true) {
        mintMode = "Public"
      } else {
        mintMode = "Not live"
      }

      let proof;
      if (pos === -1) {
        proof = undefined
      } else {
        proof = proofs[pos]
      }

      dispatch(
        fetchDataSuccess({
          totalSupply,
          maxSupply,
          cost,
          mintMode,
          proof,
          userMintAmt,
          maxPerWallet
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
